<template>
  <a-form-model
    :model="form"
    ref="form"
    :rules="rules"
    :label-col="labelCol"
    :wrapper-col="wrapperCol"
  >
    <a-form-model-item label="分类名称" prop="spiderClassName">
      <a-input v-model="form.spiderClassName" placeholder="请输入分类名称" />
    </a-form-model-item>
    <a-form-model-item label="分类类别" prop="type" >
      <a-input v-model="form.type" placeholder="请输入分类类型" :disabled="formModel" />
    </a-form-model-item>
    <a-form-model-item :wrapper-col="{ offset: 4, span: 10 }">
      <a-button style="margin-right: 10px" @click="handleCancle"> 取 消 </a-button>
      <a-button type="primary" @click="handleSubmit"
        >{{ formModel ? '修 改' : '新 增' }}
      </a-button>
    </a-form-model-item>
  </a-form-model>
</template>

<script>
import { addSpiderClassItemApi, updateSpiderClassItemApi } from '@/api/Site/Type'
export default {
  data() {
    return {
      labelCol: { span: 4 },
      wrapperCol: { span: 20 },
      form: {
        spiderClassId: '',
        spiderClassName: '',
        type: ''
      },
      rules: {
        spiderClassName: [{ required: true, message: '分类名称不可为空', trigger: ['change', 'blur'] }],
        type: [{ required: true, message: '分类类型不可为空', trigger: ['change', 'blur'] }]
      }
    }
  },
  props: ['formModel'],
  methods: {
    handleClose() {
      this.$emit('onSubmitSuccess')
    },

    handleCancle() {
      this.$emit('onClose')
    },
    async addSpiderClassItem() {
      let res = await addSpiderClassItemApi({ ...this.form })
      let { code, msg } = res
      if (code == '200') {
        this.$message.success(msg)
        this.form = {
          spiderClassId: '',
          spiderClassName: '',
          type: ''
        }
        this.handleClose()
      } else {
        this.$message.error(msg)
      }
    },

    async updatepiderClassItem() {
      let res = await updateSpiderClassItemApi({ ...this.form })
      let { code, msg } = res
      if (code == '200') {
        this.$message.success(msg)
        this.handleClose()
      } else {
        this.$message.error(msg)
      }
    },

    handleSubmit() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          if (this.formModel) {
            this.updatepiderClassItem()
          } else {
            this.addSpiderClassItem()
          }
        } else {
          return false
        }
      })
    }
  },
  watch: {
    formModel: {
      handler() {
        if (this.formModel) {
          this.form = { ...this.formModel }
        } else {
          this.form = {
            spiderClassId: '',
            spiderClassName: '',
            type: ''
          }
        }
      },
      deep: true,
      immediate: true
    }
  }
}
</script>

<style lang="less" scoped></style>
